import { DataType } from '../../data-type';

export interface ITextItem {
    property: string,
    value: any,
    label: string | React.ReactNode,
    validation: boolean,
    valid?: boolean,
    type: DataType,
    display: boolean,
    disabled?: boolean,
    values?: any[],
}